export enum PaymentTypes {
  CreditCard = 1,
  BankAccount = 2,
  PayLater = 3,
  PayPal = 4,
  GooglePay = 5,
  ApplePay = 6,
}

export enum PaymentMethod {
  CreditCard = 0,
  BankAccount = 1,
}

export enum CardTypes {
  MasterCard = 'mastercard',
  Visa = 'visa',
  Amex = 'amex',
  GooglePay = 'googlepay',
  ApplePay = 'applepay',
}
